<template>
	<div>
		<div class="TopSearch">
			<FromComm :FromArr="FromArr"></FromComm>
			<div class="btngroup">
				<CommonBtngroup ref="btngroup" :qhide="false" @select="handSearch" @reset="handReset"></CommonBtngroup>
			</div>
		</div>
		<div class="ContentView_CheckVouch">
			<div class="BottomTable">
				<Commonbtn v-if="nodeAuth.includes('delete')" backgroundColor="#FFF" title="删除" fontSize="14px"
					@btnclick="handleDel" :src="require('@/assets/icon/icon-del.png')">
				</Commonbtn>
				<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="handExport"
					:src="require('@/assets/icon/daoc.png')" />
			</div>
			<div class="custom-table">
				<el-table ref="tableRef" :data="tableData" style="width: 100%;" highlight-current-row
					@selection-change="(e)=>selectedList = e" @current-change="handleDetail">
					<el-table-column type="selection" width="55" />
					<el-table-column prop="VouCode" label="单据号" />
					<el-table-column prop="ESDate" label="空转日期" />
					<el-table-column prop="ObjName" label="付款方" />
					<el-table-column prop="TerminalHospitalName" label="终端医院" />
					<el-table-column prop="SurgeryDate" label="手术日期" />
					<el-table-column prop="SurgeryType" label="手术类型" width="80px" />
					<el-table-column prop="TechnicalOffices" label="科室" width="80px" />
					<el-table-column prop="Doctor" label="术者" width="80px" />
					<el-table-column prop="Remark" label="备注" />
					<el-table-column prop="CreateTime" label="录入日期" />
					<el-table-column prop="CreateOrgName" label="创建方" />
				</el-table>
			</div>
			<div class="pagination">
				<Pagination ref="invPagination" type='allColor' :pageSize="query.pageSize"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total">
				</Pagination>
			</div>
		</div>

		<div class="ContentView_CheckVouch" style="padding-top:24px;margin:24px 0px 200px;" v-if="tableData2.length">
			<div class="custom-table">
				<el-table ref="tableRef" :data="tableData2" style="width: 100%;">
					<el-table-column prop="InvAddCode" label="产品型号" />
					<el-table-column prop="InvName" label="产品名称" />
					<el-table-column prop="Batch" label="批号" />
					<el-table-column prop="ValiDate" label="有效期至" />
					<el-table-column prop="Quantity" label="数量" />
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
	import FromComm from '../../views/home/components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Commonbtn from '../../../components/common-btn.vue'
	import Pagination from '../../../components/pagination.vue'
	import CommonbtnUpLoad from '../../../components/common-upload.vue'
	import Commontable from '../../../components/common-table.vue'
	import FromArr from './FormData/FromArr'
	import utils from '../../../common/utils'
	import DialogFrom from '../../../components/dialog-from.vue'
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import {
		GetEmptySalesList,
		ExportEmptySales,
		DeleteEmptySales,
		GetEmptySalesDetail
	} from '@/api/newsapi'
	import {
		InventoryClassList
	} from '@/api/home'
	export default {
		components: {
			FromComm,
			CommonBtngroup,
			Commonbtn,
			Pagination,
			CommonbtnUpLoad,
			Commontable,
			DialogFrom,
			Commondropdownlist
		},
		computed: {
			CusType() {
				return this.$store.state.MenusData.CusType;
			},
			menusData() {
				return this.$store.state.MenusData.Menus;
			}
		},
		data() {
			return {
				total: 0,
				query: {
					pageIndex: 1,
					pageSize: 10
				},
				FromArr: [],
				tableData: [],
				dialogVisible: false,
				selectedList: [],
				nodeAuth: [],
				tableData2: []
			}
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.FromArr[1].StartTime = this.$utils.getFYearDate();
			this.InventoryClassList();
			this.getData();
			this.setMenuList();
			if (this.CusType) {
				this.FromArr.splice(9, 1);
			}
			console.log(this.menusData)
		},
		methods: {
			setMenuList() {
				let NodeInfo = this.menusData.filter(item => item.NodeID === '24')[0].Nodes.filter(item => item.NodeID ===
					'1084')[0];
				this.nodeAuth = NodeInfo.Nodes && NodeInfo.Nodes.map(item => item.NodeName);
			},
			//查询列表数据
			async getData() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				this.query.VouCode = this.FromArr[0].modelvalue;
				this.query.ESDate1 = this.FromArr[1].StartTime;
				this.query.ESDate2 = this.FromArr[1].EndTime;
				this.query.ObjName = this.FromArr[2].modelvalue;
				this.query.TerminalHPName = this.FromArr[3].modelvalue;
				this.query.InvClass = this.FromArr[4].modelvalue;
				this.query.CreateTime1 = this.FromArr[5].modelvalue;
				this.query.CreateTime2 = this.FromArr[5].modelvalue;
				this.query.InvAddCode = this.FromArr[6].modelvalue;
				this.query.InvName = this.FromArr[7].modelvalue;
				this.query.Batch = this.FromArr[8].modelvalue;
				if (this.FromArr.length == 10) {
					this.query.CreateOrgName = this.FromArr[9].modelvalue;
				}
				let {
					code,
					data,
					message
				} = await GetEmptySalesList(this.query)
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data.map(it => {
						it.SurgeryDate = it.SurgeryDate ? it.SurgeryDate.substring(0, 10) : '';
						it.ESDate = it.ESDate ? it.ESDate.substring(0, 10) : '';
						it.CreateTime = it.CreateTime ? it.CreateTime.substring(0, 10) : '';
						return it;
					});
					loading.close();
				} else {
					loading.close();
					this.$message.error(message);
				}
			},
			//详情
			async handleDetail(e) {
				let {
					code,
					data,
					message
				} = await GetEmptySalesDetail({
					ESMID: e.ESMID
				})
				if (code == 0) {
					this.tableData2 = data;
				} else {
					this.$message.error(message);
				}
			},
			// 产品线下拉
			async InventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({});
				if (code == 0) {
					this.FromArr[4].options = []
					data.data.map((item, index) => {
						this.FromArr[4].options.push({
							key: item.InvClass,
							value: item.InvClassName
						})
					})
				}
			},
			//导出
			async handExport(e) {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				this.query.VouCode = this.FromArr[0].modelvalue;
				this.query.ESDate1 = this.FromArr[1].StartTime;
				this.query.ESDate2 = this.FromArr[1].EndTime;
				this.query.ObjName = this.FromArr[2].modelvalue;
				this.query.TerminalHPName = this.FromArr[3].modelvalue;
				this.query.InvClass = this.FromArr[4].modelvalue;
				this.query.CreateTime1 = this.FromArr[5].modelvalue;
				this.query.CreateTime2 = this.FromArr[5].modelvalue;
				this.query.InvAddCode = this.FromArr[6].modelvalue;
				this.query.InvName = this.FromArr[7].modelvalue;
				this.query.Batch = this.FromArr[8].modelvalue;
				if (this.FromArr.length == 10) {
					this.query.CreateOrgName = this.FromArr[9].modelvalue;
				}
				let resexprot = await ExportEmptySales(this.query)
				loading.close();
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `空转信息${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
			},
			async handleDel() {
				if (!this.selectedList.length) {
					this.$message.warning('请勾选');
					return;
				}
				let {
					code,
					data,
					message
				} = await DeleteEmptySales({
					ESMIDs: this.selectedList.map(it => it.ESMID),
				});
				if (code == 0) {
					this.selectedList = [];
					this.$message.warning('删除成功');
					this.getData();
					this.$refs.tableRef.clearSelection();
				} else {
					this.$message.error(message);
				}
			},
			handSearch() {
				this.query.pageIndex = 1;
				this.getData();
			},
			handReset() {
				this.query = {
					pageIndex: 1,
					pageSize: 10
				};
				this.FromArr.map((item, index) => {
					item.modelvalue = '';
					item.StartTime = '';
					item.EndTime = '';
					return item;
				})
				this.getData();
			},
			handleCurrentChange(e) {
				this.query.pageIndex = e
				this.getData()
			},
			handleSizeChange(e) {
				this.query.pageSize = e
				this.getData()
			}
		},
	}
</script>

<style lang="less" scoped>
	.TopSearch {
		height: 240px;
		margin: 0px 0px 8px;
		background: #FFFFFF;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);

		.btngroup {
			// border: 1px solid #0b65ec;
			position: relative;
			//bottom: 21px;
		}
	}

	.ContentView_CheckVouch {
		background: #FFFFFF;

		.BottomTable {
			padding: 10px 0px;
		}

		.ativte {
			border: 1px solid red;
			color: #e71d43;
			background-color: #fce8ec;
			transition: 0.2s linear;
		}

		.incenters {
			padding: 14px 4px;

			div {
				margin-left: 8px;
				margin-right: 8px;
				margin-top: 5px;
				margin-bottom: 5px;
				// width: 100%;
			}
		}

		.topstate {
			width: 100px;
			height: 32px;
			font-size: 14px;
			border: 1px solid #e6e6e6;
			line-height: 32px;
			text-align: center;
			cursor: pointer;
			display: inline-block;
			user-select: none;
		}

		.custom-table {
			padding: 0px 0px 24px 0px;

			/deep/.el-table .el-table__cell {
				padding: 8px 0;

				.cell {
					.update_ipt {
						.el-input__inner {
							height: 28px;
							line-height: 28px;
							border-radius: 0px;
						}

						.el-input__inner:focus {
							border-color: #e71d43;
						}
					}

					.table-export {
						color: #e71d43;
						cursor: pointer;
					}
				}
			}

			/deep/.el-table th.el-table__cell {
				background: #F3F3F3;
			}


			/deep/.el-table {
				.el-checkbox__input.is-checked .el-checkbox__inner,
				.el-checkbox__input.is-indeterminate .el-checkbox__inner {
					background-color: #e71d43;
					border-color: #e71d43;
				}
			}

			// /deep/.el-table__body {
			// 	td {
			// 		padding: 0px 0 !important;
			// 		cursor: pointer;
			// 	}
			// }
		}

	}

	.from-table {
		//padding: 0px 24px 24px 24px;

		/deep/.el-table .el-table__cell {
			padding: 8px 0;
		}

		/deep/.el-table th.el-table__cell {
			background: #F3F3F3;
		}
	}
</style>